import React,{useState} from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import NavBar from './components/NavBar/NavBar';
import Cookies from 'js-cookie';
import Hero from './components/Hero/Hero'
import Counts from './components/Counts/Counts';
import Services from './components/Services/Services';
import './App.css';
import Projects from './components/Projects/Projects';
import Customers from './components/Customers/Customers';
import Aboutus from './components/Aboutus/Aboutus';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';


function App() {
  let Cookieslan = Cookies.get('i18next');
  if(Cookieslan === 'en'){
    Cookieslan = 'ltr';
  }if(Cookieslan === 'ar'){
    Cookieslan = 'rtl';
  }
  //change dir and lang 
  const [ddir, setDdir] = useState(Cookieslan);
  const className =  ddir ;
  return (
    <div className={"App " + className}>
      <NavBar onDirChange={setDdir} />
      <Hero />
      <Counts />
      <Services />
      <Projects />
      <Customers />
      <Aboutus  />
      <Contact />
      <Footer />
      
    </div>
  );
}

export default App;
